export default {
  Google: {
    clientId:
      '499331906253-1l8utknmvsh37udebkfikaicnjo4rkd3.apps.googleusercontent.com',
    clientSecret: 'cDGzdiGVdsI1AKd9XWhM-vSt',
    scope: 'profile email',
    hostedDomain: 'computas.com',
  },
};
